import { render, staticRenderFns } from "./FormMobileNotification.vue?vue&type=template&id=7ca8ef77&"
import script from "./FormMobileNotification.vue?vue&type=script&lang=js&"
export * from "./FormMobileNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports